<!--  https://xd.adobe.com/view/043c2377-c87d-41bf-b429-2ffe2322e7ce-516f/specs/
https://docs.google.com/presentation/d/1UivJFMHQGhHTr5JY2Nq057cU3yz4bjN19aF1Y7TOsnw/edit#slide=id.g13fb061f812_3_1
https://docs.google.com/presentation/d/13UsZSW6pwkxbykyikLyZZ6SMvyENk4zDX6HOSUztTt4/edit#
https://docs.google.com/presentation/d/1KoLwxK6SmXHDFyi8c-3t10mt-BctVg1eYVhkBoeIMSY/edit?pli=1#slide=id.g14a795ef9d9_2_81
https://docs.google.com/presentation/d/1KoLwxK6SmXHDFyi8c-3t10mt-BctVg1eYVhkBoeIMSY/edit#slide=id.g14a795efe1d_2_4
https://xd.adobe.com/view/b227e3f6-fc94-43e2-9120-1b63d2ea3fdb-e774/specs/
-->
<template>
  <div id="contract-main-viewer" class="clearfix noto-sans darkblue px2 mb4">
    <div class="col-12">
          <div class="clearfix ">
            <div class="col-12 mt2 px0 flex justify-between items-center">
                <p class="h1 regular line-height-2 my3 ">Udkast til Kontrakt</p>
            </div>

            <div>
              <!-- <p class=" darkblue font14 col-12 m0 p0">Fremhæv den tekst, du vil kommentere</p> -->
              <!-- <el-select v-model="selectedDocumentVersion" @change="changeDocument()" filterable default-first-option  class="col-12 p0 capital mb2" >
                <el-option
                  v-for="(document, index) in contractInfo.documents"
                  :key="index"
                  :label="document.TITLE + ' - ' + document.CREATE_TIME"
                  :value="index"
                  class="cyprus">
                </el-option>
              </el-select> -->
              <div class="flex flex-row mobile-flex-column col-12 m0 pb2 p0 " style="gap:10px">
                <div class="highlights border col-12 mp0">
                  <div class="flex justify-end">
                    <button class="p1 m1 action-button" @click="ConfirmVisible = true, initiateSignaturepad()" v-if="confirmstatus === ''">Bekræft</button>
                    &nbsp;
                    <button class="p1 m1 primary-button" @click="showComposeForm()"><i class="el-icon-circle-plus"></i> Send besked til {{contact}}</button>
                  </div>
                  <div class="flex justify-center" v-if="ConfirmVisible">
                    <form class="payProff">
                      <div class="col-12 flex justify-between items-center p0">
                        <p class="h5 cyprus regular line-height-1 m0 p2">Underskriv her</p>
                        <b-button variant="outline-danger" size="sm" @click="clearSignature()">Slet</b-button>
                      </div>
                      <div class="clearfix">
                        <!-- <div class="col-4 p0 flex justify-between">
                          <div class="col-4 p0 pr2" id="signature-control" >
                            < !-- <ejs-signature  ></ejs-signature> -- >
                          </div>
                        </div> -->
                        <div id="signature-pad" class="signature-pad col-12 height-full">
                          <div class="signature-pad--body">
                            <canvas width="664" style="touch-action: none; user-select: none;" height="339"></canvas>
                          </div>
                        </div>
                        <p class="mr-auto p0 py2 mo h6"><el-checkbox class="saveSignature" v-model="confirmTerms"><span class="pointer" @click="termspopup = true">{{termslabel}}</span></el-checkbox></p>
                        <div class="col-12 p0 flex justify-between items-center">
                          <button type="button" class="mr2 muted-button button-padding border-none not-rounded h5 regular line-height-1 p2"  @click="ConfirmVisible = false" >
                            <span class="mr1"></span>Annuller
                          </button>
                          <button type="button" class="action-button button-padding border-none not-rounded h5 regular line-height-1 p2" @click="confirmcontract()">
                            Bekræft
                            <span class="ml1"></span>
                          </button>
                        </div>
                      </div>
                    </form>
                    <div class="py2"></div>
                  </div>
                  <div class="py1 col-12 p0 relative" style="" >
                    <!-- <ejs-pdfviewer  id="pdfViewer" ref="pdfviewer" :ajaxRequestFailure="ajaxRequestFailure" :annotationRemove="exportAnnotation" :commentAdd="exportAnnotation" :commentDelete="exportAnnotation" :commentEdit="exportAnnotation"  :annotationAdd="exportAnnotation" :annotationPropertiesChange="exportAnnotation"  :serviceUrl="serviceUrl" :enableToolbar="true" height="1100px"  :documentLoad="documentLoad" :created="getContract" :documentPath="documentPath"> </ejs-pdfviewer> -->
                    <!-- <vue-pdf-app :pdf="pdfStr" theme="light" :page-scale="scale" style="height: 100vh;" :config="config" @pages-rendered="pagesRenderedHandler"></vue-pdf-app> -->
                    <b-embed type="iframe" aspect="16by9" :src="pdfStrlink" allowfullscreen></b-embed>
                  </div>
                </div>
              </div>
                <div class="py3"></div>
            </div>
          </div>
      </div>
      <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
      <loading :show="show" :label="label" :overlay="overlay"></loading>
    <b-modal hide-footer size="lg" centered lazy v-model="composeFormVisible" ref="formModal" class="p2 pb4" no-close-on-backdrop>
      <div slot="modal-header" class="pt2 px0">
        <div class="clearfix">
          <div class="col-12 px2">
            <p class="h4 darkblue gibson line-height-1 semi-bold">
              Skriv til ...
            </p>
          </div>
        </div>
      </div>
      <div></div>
      <span class="h5 bold darkblue">Ny besked</span>
      <div class="mb4"></div>
      <form>
        <div class="form-group">
          {{contact}}
        </div>
        <div class="form-group">
          <el-input placeholder="Title" v-model="composeForm.title" class="col-12 p0"></el-input>
        </div>
        <div class="form-group mb4">
          <wysiwyg placeholder="Notat" class="mb2" required v-model="composeForm.message"/>
        </div>
        <div class="flex justify-end">
          <button type="button" class="col-2 right block muted-button button-padding border-none not-rounded h5 regular line-height-1 ml1 py2 px1" @click="composeFormVisible = false">
            <span>Luk</span>
          </button>
          <button type="button" @click="sendmessage()" class="col-2 right block action-button button-padding border-none not-rounded h5 regular line-height-1 ml1 py2 px1">
            <span>Send</span>
          </button>
        </div>
      </form>
    </b-modal>
    <b-modal centered hide-footer v-model="payproffform" id="payproffform" ref="payproffform"  size="lg" no-close-on-esc no-close-on-backdrop>
        <div class="col-11 flex justify-between items-center pt1 p0 mx-auto my2">
          <div class="col-5">
            <p class="mr-auto h5 cyprus semi-bold line-height-1 m0 p0">Payproff Form
            </p>
          </div>
          <div class="col-3 ml-auto flex justify-end h4 p0 primary-white-button pointer close m0" @click="closepayproffform()">
            <i class="el-icon-circle-close"></i>
          </div>
        </div>
      <div class="clearfix">
        <div class="hide">
          <div class="flex flex-column ">
            <span class=""><i class="el-icon-loading"></i></span>
            <p class="h6 regular small">Godkendt af Finanstilsynet</p>
            <p class="p0 m0"><i class="el-icon-warning-outline"></i><span class="">Information</span></p>
            <div>

            </div>
          </div>
        </div>
        <div id="payproff" class="darkblue notosans">
          <el-form id="cvrfrom" :model="payprofform" class="md-col-11 lg-col-11 sm-col-12 mx-auto p2" :rules="payprofformfules" ref="payprofform" label-position="top">
            <form-wizard ref="createPayproffFormWiz" shape="tab" color="#ffffff">
              <tab-content>
                <div class="clearfix">
                  <div class="mb2 flex flex-column items-start p0">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="152.26" height="35.735" viewBox="0 0 152.26 35.735">
                      <defs>
                        <clipPath id="clip-path">
                          <rect id="Rectangle_1428" data-name="Rectangle 1428" width="152.26" height="35.735" fill="#2265fc"/>
                        </clipPath>
                      </defs>
                      <g id="Payproff_logo" clip-path="url(#clip-path)">
                        <path id="Path_4272" data-name="Path 4272" d="M820.931,52.36v0Z" transform="translate(-668.671 -41.591)" fill="#2265fc"/>
                        <path id="Path_4273" data-name="Path 4273" d="M820.931,78.36v0Z" transform="translate(-668.671 -62.769)" fill="#2265fc"/>
                        <path id="Path_4274" data-name="Path 4274" d="M3.494,27.738a3.853,3.853,0,0,1,.3-.372q2.463-2.4,4.931-4.8c.271-.264.549-.523.8-.808a.759.759,0,0,1,.633-.259q3.152.009,6.305.01c1.97,0,3.941.024,5.912-.007A9.011,9.011,0,0,0,28.8,18.744,8.648,8.648,0,0,0,31.36,13.45a9.011,9.011,0,0,0-5.207-9.257,9.5,9.5,0,0,0-4.171-.9q-10.8.015-21.607,0C.254,3.3.132,3.281,0,3.272V.022C.073.017.14.007.207.007c7.5,0,14.992-.016,22.487,0a11.9,11.9,0,0,1,6.235,1.822,12.161,12.161,0,0,1,5.7,7.677,11.819,11.819,0,0,1-1.288,9.005,12.351,12.351,0,0,1-5.591,5.1,13.307,13.307,0,0,1-5.745,1.244q-5.332.014-10.664,0a.509.509,0,0,0-.4.17C9.7,26.257,8.445,27.47,7.2,28.69c-.979.956-1.952,1.917-2.929,2.874Q2.3,33.493.323,35.42L0,35.735V10.221H26.076l.036.047L25.357,11q-2.207,2.135-4.413,4.272-1.355,1.317-2.692,2.65a.686.686,0,0,1-.529.22c-1.429-.008-2.859,0-4.288,0a.6.6,0,0,1-.094-.028l4.634-4.548H3.428v14.1l.067.072" transform="translate(0 0)" fill="#2265fc"/>
                        <path id="Path_4275" data-name="Path 4275" d="M472.8,65.616v-2.6c.058,0,.125-.009.192-.009q2.828,0,5.656.008a3.2,3.2,0,0,0,1.457-.308,1.853,1.853,0,0,0,1.124-1.607,11.79,11.79,0,0,0-.017-1.9A2.135,2.135,0,0,0,479,57.22c-2.04,0-4.08,0-6.12,0q-.116,0-.232.006a.9.9,0,0,0-.936,1q0,5.32,0,10.64c0,.062-.008.124,0,.185.012.14-.047.19-.188.189q-1.205-.007-2.411,0c-.136,0-.178-.057-.173-.181,0-.085,0-.17,0-.255q0-5.077,0-10.153a4.575,4.575,0,0,1,.334-1.856,3.527,3.527,0,0,1,2.549-2.057,4.586,4.586,0,0,1,1.053-.135q3.06-.019,6.12,0a4.823,4.823,0,0,1,4.967,4.65,15.076,15.076,0,0,1-.083,2.473,4.341,4.341,0,0,1-2.755,3.434,5.416,5.416,0,0,1-2.2.474c-1.955.007-3.91,0-5.865,0-.075,0-.15-.01-.248-.016" transform="translate(-381.958 -44.465)" fill="#2265fc"/>
                        <path id="Path_4276" data-name="Path 4276" d="M224.51,65.464c0-.844,0-1.654.006-2.464,0-.046.082-.122.134-.13a3.038,3.038,0,0,1,.439-.017q2.688,0,5.377,0a3.091,3.091,0,0,0,1.369-.287,1.816,1.816,0,0,0,1.1-1.449,6.616,6.616,0,0,0-.041-2.326,2.088,2.088,0,0,0-2.2-1.727q-3.036,0-6.073,0a1.92,1.92,0,0,0-.549.058.85.85,0,0,0-.64.794c-.022.3-.008.6-.008.9q0,4.995.014,9.989c0,.215-.06.275-.275.272-.742-.013-1.483-.009-2.225,0-.182,0-.235-.049-.235-.236.012-3.523.045-7.046.012-10.568a3.649,3.649,0,0,1,3.223-3.8,5.437,5.437,0,0,1,.9-.073c2.024,0,4.049-.022,6.072.035a4.77,4.77,0,0,1,4.768,4.515,9.31,9.31,0,0,1-.115,2.905,4.434,4.434,0,0,1-2.624,3.1,5.364,5.364,0,0,1-2.285.513c-1.924.009-3.847.008-5.771.009-.114,0-.228-.013-.369-.021" transform="translate(-179.766 -44.315)" fill="#2265fc"/>
                        <path id="Path_4277" data-name="Path 4277" d="M312.791,73.965c.966,0,1.933-.039,2.9.009a3.634,3.634,0,0,1,3.192,1.9,3.87,3.87,0,0,1,.447,1.9c.01,1.058.03,2.118-.009,3.175a6.291,6.291,0,0,1-.254,1.592,3.38,3.38,0,0,1-3.3,2.439c-1.845.043-3.7.079-5.537-.042a3.645,3.645,0,0,1-.944-7.043,3.37,3.37,0,0,1,1.085-.206c1.661-.025,3.322-.016,4.983-.024.181,0,.235.06.232.243-.011.7-.009,1.391,0,2.086,0,.166-.032.219-.219.218q-2.387-.014-4.775,0a1.06,1.06,0,0,0-1.1,1.115,1.091,1.091,0,0,0,1.048,1.143c.363-.009.726.01,1.089.011q1.947.006,3.894.007a1.08,1.08,0,0,0,1.219-1.211q0-1.773,0-3.547c0-.856-.379-1.26-1.238-1.264-1.87-.009-3.74,0-5.61.006-.314,0-.316,0-.318-.3,0-.68,0-1.36-.01-2.04,0-.12.029-.173.149-.174s.232-.009.347-.009h2.735v.022" transform="translate(-249.978 -60.229)" fill="#2265fc"/>
                        <path id="Path_4278" data-name="Path 4278" d="M628.743,85.006c-.965,0-1.933.043-2.9-.009a3.587,3.587,0,0,1-3.32-2.931,3.247,3.247,0,0,1-.057-.576c0-1.267-.02-2.534,0-3.8a3.48,3.48,0,0,1,1.815-3.153,4.052,4.052,0,0,1,2.02-.513c1.684-.016,3.369-.035,5.052,0a3.511,3.511,0,0,1,3.173,1.873,3.728,3.728,0,0,1,.455,1.824c.006,1.275.023,2.55-.009,3.824A3.5,3.5,0,0,1,631.592,85c-.945.068-1.9.012-2.849.012v0m.007-2.593h0c.85,0,1.7,0,2.549,0a.9.9,0,0,0,1-.968c.006-1.305-.006-2.611,0-3.916a.824.824,0,0,0-.3-.627,1,1,0,0,0-.719-.266c-1.645,0-3.291-.026-4.936,0-.87.012-1.2.4-1.189,1.275q0,.6.009,1.205c.006.765-.012,1.53.024,2.294.034.716.363,1,1.085,1.007.826.006,1.653,0,2.48,0" transform="translate(-507.012 -60.278)" fill="#2265fc"/>
                        <path id="Path_4279" data-name="Path 4279" d="M702.866,63.913V63.45q0-5.885.007-11.771a3.559,3.559,0,0,1,3.1-3.52,7.6,7.6,0,0,1,1.291-.1c1.746-.01,3.491,0,5.237,0h.294v2.651c-2.045,0-4.06,0-6.075,0-.579,0-.961.214-1.091.667a1.75,1.75,0,0,0-.058.48q.007,5.828.021,11.656c0,.4,0,.4-.394.4-.764,0-1.527,0-2.333,0" transform="translate(-572.504 -39.143)" fill="#2265fc"/>
                        <path id="Path_4280" data-name="Path 4280" d="M766.72,57.5c0-1.916.021-3.832-.006-5.748a3.561,3.561,0,0,1,3.406-3.635c1.223-.087,2.455-.047,3.683-.057.865-.007,1.731,0,2.6,0,.191,0,.251.053.246.253q-.025,1.064-.009,2.128c0,.226-.069.287-.292.285-1.839-.01-3.677-.008-5.516-.007-.193,0-.386.007-.578.026a.925.925,0,0,0-.86.826,3.722,3.722,0,0,0-.036.508q0,5.157.009,10.314c0,.432.012.865.028,1.3.006.166-.04.233-.22.231-.757-.008-1.514-.006-2.271,0-.156,0-.194-.058-.194-.206q.006-3.105,0-6.211h.012" transform="translate(-624.503 -39.14)" fill="#2265fc"/>
                        <path id="Path_4281" data-name="Path 4281" d="M412.671,73.944h.568c.641,0,1.282.011,1.923,0,.188,0,.249.054.249.25q-.011,5.921-.009,11.842a3.551,3.551,0,0,1-3.539,3.724c-1.533.086-3.073.031-4.61.036-.571,0-.559,0-.55-.563.01-.625,0-1.251-.012-1.876,0-.17.039-.227.217-.227,1.483.006,2.966,0,4.449,0,.116,0,.232.007.347.016a.857.857,0,0,0,.97-.851c.009-.169,0-.34,0-.509q0-5.794,0-11.587Z" transform="translate(-331.26 -60.229)" fill="#2265fc"/>
                        <path id="Path_4282" data-name="Path 4282" d="M570.408,74.061c0,.444,0,.852,0,1.26,0,.379.006.757.021,1.135.007.165-.031.231-.216.23q-2.815-.018-5.631-.018a3.916,3.916,0,0,0-.553.039.915.915,0,0,0-.835.8,2.784,2.784,0,0,0-.033.484q0,3.453.013,6.905c0,.06-.011.119-.019.195h-2.05c-.629,0-.629,0-.629-.624q0-3.279,0-6.558a3.867,3.867,0,0,1,.442-1.941,3.707,3.707,0,0,1,3.005-1.858,9.542,9.542,0,0,1,1.11-.049c1.7,0,3.4,0,5.1,0h.276" transform="translate(-456.523 -60.325)" fill="#2265fc"/>
                        <path id="Path_4283" data-name="Path 4283" d="M385.931,74.055c.862,0,1.7,0,2.544,0,.16,0,.169.086.169.206,0,.571,0,1.143,0,1.715q0,2.642,0,5.283a1.965,1.965,0,0,0,.034.46.954.954,0,0,0,1.062.731q2.015-.025,4.03-.045c.285,0,.57,0,.881,0,.009.092.022.174.023.255,0,.726,0,1.452.009,2.177,0,.21-.066.26-.264.259-1.545-.008-3.09.014-4.634-.012a3.806,3.806,0,0,1-3.076-1.4,3.584,3.584,0,0,1-.784-2.256c-.019-2.417-.007-4.835-.007-7.253,0-.03.006-.059.012-.117" transform="translate(-314.339 -60.317)" fill="#2265fc"/>
                        <path id="Path_4284" data-name="Path 4284" d="M723.448,73.962h.326c1.847,0,3.693.006,5.54,0,.225,0,.306.051.3.3-.021.7-.015,1.406-.007,2.109,0,.192-.06.248-.254.247-1.87-.009-3.739-.008-5.609-.009-.3,0-.3,0-.3-.291q0-1.089-.006-2.179c0-.045,0-.09.007-.175" transform="translate(-589.263 -60.244)" fill="#2265fc"/>
                        <path id="Path_4285" data-name="Path 4285" d="M787.263,73.973h.285q2.756,0,5.511,0c.329,0,.32.005.317.339q-.009,1.029,0,2.058c0,.158-.027.239-.214.239q-2.837-.01-5.674-.006c-.119,0-.231.022-.23-.164.006-.809,0-1.618,0-2.469" transform="translate(-641.245 -60.253)" fill="#2265fc"/>
                      </g>
                    </svg>
                    <span>Godkendt af Finanstilsynet</span>
                  </div>
                  <div class="flex justify-start items-center cyprus">
                    <span>
                      <svg fill="currentColor" class="block" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-.001 5.75c.69 0 1.251.56 1.251 1.25s-.561 1.25-1.251 1.25-1.249-.56-1.249-1.25.559-1.25 1.249-1.25zm2.001 12.25h-4v-1c.484-.179 1-.201 1-.735v-4.467c0-.534-.516-.618-1-.797v-1h3v6.265c0 .535.517.558 1 .735v.999z"/></svg>
                    </span>
                    <p class="h5 line-height-1 m0 ml1 p0">Information</p>
                  </div>
                  <div class="py1"></div>
                  <div class="clearfix pr3 mb2">
                    <p class="line-height-4 mt1">For at sikre en tryg oplevelse i hele forløbet, har vi hos Håndværker.dk indgået et samarbejde med PayProff, om en deponeringskonto til opbevaring af din kundes penge, indtil projektet er fuldført.
                    </p>
                    <p class="line-height-4 mt1">PayProff er godkendt som betalingstjeneste hos Finanstilsynet. Du kan se deres licens  <a class="semi-bold" href="https://virksomhedsregister.finanstilsynet.dk/virksomhed-under-tilsyn.html?v=30F336FD-6CE2-EC11-A2DB-005056907186" target="_blank">her</a>, og læse mere om de godkendelser, de har fået
                    </p>
                    <p class="line-height-4 mt1">
                    PayProff er en betalingsløsning skabt til at bringe sikkerhed ind i online pengehandel. Din kunde overfører entreprisesummen til kontoen, hvor de opbevares mens opgaven står på. Når opgaven er udført, kan du anmode om en udbetaling fra kunden, der via sin PayProff profil skal godkende udbetalingen.</p>
                    <p class="line-height-4 mt1">Det er med til at sikre dig, at der er en betaling klar, når projektet afsluttes.</p>
                  </div>
                  <div>
                    <el-collapse v-model="activeNames" accordion>
                      <el-collapse-item name="1">
                        <template slot="title">
                          <span class="h6 line-height-1 m0 p0 semi-bold py1">Hvorfor har du brug for mine bankoplysninger?</span>
                        </template>
                        <p class="line-height-golden">Vi har brug for dine bankoplysninger for at sende dig pengene eller for at
                          refundere dig, hvis det er nødvendigt. Det betyder også, at du ikke behøver
                          at dele dine bankoplysninger med din kontraktpartner.</p>
                      </el-collapse-item>
                      <el-collapse-item name="2">
                        <template slot="title">
                          <span class="h6 line-height-1 m0 p0 semi-bold py1">Hvordan overfører jeg pengene til PayProff?</span>
                        </template>
                        <p class="line-height-golden">De tilgængelige betalingsmetoder er: bankoverførsel, snart også i VISA,
                          Mastercard, Dankort og Mobilepay. Ved bankoverførsler får du alle de
                          bankoplysninger og referencenummer, du skal bruge input, når du foretager
                          overførslen. Bemærk venligst, at hvis du ikke indtaster det korrekte
                          referencenummer Der kan opstå forsinkelser, da vores system ikke vil være
                          i stand til at afstemme din betaling med det samme.</p>
                      </el-collapse-item>
                      <el-collapse-item name="3">
                        <template slot="title">
                          <span class="h6 line-height-1 m0 p0 semi-bold py1">Hvorfor bliver jeg stillet ekstra sikkerhedsspørgsmål?</span>
                        </template>
                        <p class="line-height-golden">For at overholde lovmæssige krav skal vi muligvis stille dig et par
                          ekstra spørgsmål. Dette er normal procedure for at sikre, at vi forstår,
                          hvordan du vil bruge vores tjenester, og det hjælper vi bekæmper
                          økonomisk kriminalitet.</p>
                      </el-collapse-item>
                      <el-collapse-item name="4">
                        <template slot="title">
                          <span class="h6 line-height-1 m0 p0 semi-bold py1">Hvorfor skal PayProff bekræfte min identitet? Hvad er Kend din kunde (KYC)?</span>
                        </template>
                        <p class="line-height-golden">PayProff er forpligtet til at levere et sikkert og sikkert miljø. Desuden har vi
                          en juridisk forpligtelse til ved, hvem vores kunder er. Det betyder, at hvis du
                          er privatperson, skal vi udføre en identitetsbekræftelse med NemID i Danmark.
                          Flere muligheder om identitetsbekræftelse både for private enkeltpersoner
                          og virksomheder i og uden for Danmark stilles til rådighed i 3. kvartal 2021.</p>
                      </el-collapse-item>
                    </el-collapse>
                  </div>
                </div>
              </tab-content>
              <tab-content :before-change="validateCreatePayproffFirstTab">
                <div class="flex flex-row mobile-flex-column">
                  <div class="m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-6">
                    <el-form-item label="Fornavn" prop="fornavn" class="border-none el-form-opgavetype  p0 mr-auto" >
                        <el-input v-model.number="payprofform.fornavn" maxlength="8" class=" white-background" placeholder="fornavn" clearable></el-input>
                    </el-form-item>
                    </div>
                    <div class="m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-6">
                    <el-form-item label="Efternavn" id="efternavn" prop="efternavn" class="border-none el-form-opgavetype  ml-auto">
                        <el-input v-model="payprofform.efternavn"  class=" white-background" placeholder="efternavn" clearable></el-input>
                    </el-form-item>
                  </div>
                </div>
                <!-- <el-alert type="error" effect="light" show-icon :closable="false" class="line-height-1 col-12 mx-auto"></el-alert> -->
                <div class="flex flex-row mobile-flex-column">
                  <div class="m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-6">
                    <el-form-item label="Mellemnavn" prop="mellemnavn" class="border-none el-form-opgavetype  p0 mr-auto">
                        <el-input v-model="payprofform.mellemnavn" class=" white-background" placeholder="mellemnavn" clearable></el-input>
                    </el-form-item>
                    </div>
                    <div class="m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-6">
                    <el-form-item label="Fodelsdag" id="fodelsdag" prop="fodelsdag" class="border-none el-form-opgavetype  p0 ml-auto">
                        <datepicker id="datepickeroffer2" v-model="payprofform.fodelsdag" class="col-12 m0 p0" :bootstrapStyling="false" placeholder="Fodelsdag" :language="da"></datepicker>
                    </el-form-item>
                  </div>
                </div>
                <div class="flex flex-row mobile-flex-column">
                  <div class="m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-12">
                    <el-form-item label="Adresse" prop="Adresse" class="border-none el-form-opgavetype p0 mr-auto">
                        <el-input v-model="payprofform.Adresse"  class=" white-background" placeholder="Strandlodsvej 6, 1. sal" clearable></el-input>
                    </el-form-item>
                    </div>
                    <div class="m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-12">
                    <el-form-item label="zipcode" id="zipcode" prop="zipcode" class="border-none el-form-opgavetype p0 ml-auto">
                        <el-input v-model="payprofform.zipcode"  class=" white-background" placeholder="2300" clearable></el-input>
                    </el-form-item>
                  </div>
                </div>
                <div class="flex flex-row mobile-flex-column">
                  <div class="m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-12">
                    <el-form-item label="By" prop="by" class="border-none el-form-opgavetype p0 mr-auto">
                        <el-input v-model="payprofform.by"  class=" white-background" placeholder="København s" clearable></el-input>
                    </el-form-item>
                    </div>
                    <div class="m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-12">
                    <el-form-item label="Stat" id="stat" prop="stat" class="border-none el-form-opgavetype p0 ml-auto">
                        <el-input v-model="payprofform.stat"  class=" white-background" placeholder="stat" clearable></el-input>
                    </el-form-item>
                  </div>
                </div>
                <div class="flex flex-row mobile-flex-column">
                  <div class="m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-12">
                    <el-form-item label="Email" prop="email" class="border-none el-form-opgavetype p0 mr-auto">
                        <el-input v-model="payprofform.email"  class=" white-background" placeholder="E-mail" clearable></el-input>
                    </el-form-item>
                    </div>
                    <div class="m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-12">
                      <el-form-item label="Land" id="land" prop="land" class="border-none el-form-opgavetype p0 ml-auto">
                          <el-select class="white-background" v-model="payprofform.land" filterable clearable placeholder="Country">
                            <el-option v-for="(country, index) in countryData" :key="index" :label="country" :value="index">
                            </el-option>
                          </el-select>
                      </el-form-item>
                    </div>
                </div>
                <div class="flex flex-row mobile-flex-column">
                    <div class="m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-12">
                      <el-form-item label="Telefonnummer" id="telefonnummer" prop="telefonnummer" class="border-none el-form-opgavetype p0 ml-auto">
                          <el-input v-model.number="payprofform.telefonnummer" maxlength="8" class=" white-background"  placeholder="Tel.(8 cifre)" clearable></el-input>
                      </el-form-item>
                    </div>
                    <div class="m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-12">
                      <el-form-item label="Telefon contry code" id="telcountrycode" prop="telcountrycode" class="border-none el-form-opgavetype p0 ml-auto">
                          <el-input v-model.number="payprofform.telcountrycode" class="white-background"  placeholder="+45" clearable></el-input>
                      </el-form-item>
                    </div>
                </div>
                <div class="flex flex-row mobile-flex-column">
                    <div class="m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-12">
                      <el-form-item label="CPR nummer" id="cprnummer" prop="cprnummer" class="border-none el-form-opgavetype p0 ml-auto">
                          <el-input v-model.number="payprofform.cprnummer" maxlength="10" class=" white-background"  placeholder="XXXXXXXXXX" clearable></el-input>
                      </el-form-item>
                    </div>
                    <div class="m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-12">
                      <el-form-item label="Sprog" id="sprog" prop="sprog" class="border-none el-form-opgavetype p0 ml-auto">
                          <el-select class="white-background" v-model="payprofform.sprog" filterable placeholder="sprog" clearable>
                            <el-option v-for="(language, index) in languagesData" :key="index" :label="language" :value="index">
                            </el-option>
                          </el-select>
                      </el-form-item>
                    </div>
                </div>
                <div class="flex flex-row mobile-flex-column">
                    <div class="m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-12">
                      <el-form-item label="Betalingsmiddel" id="currency" prop="currency" class="border-none el-form-opgavetype p0 ml-auto">
                          <el-select class="white-background" v-model="payprofform.currency" filterable clearable placeholder="DKK">
                            <el-option vlabel="DKK" value="DKK">
                            </el-option>
                            <el-option vlabel="EUR" value="EUR">
                            </el-option>
                          </el-select>
                      </el-form-item>
                    </div>
                </div>
              </tab-content>
              <!-- <div class="flex ">
                <button type="button" @click="clear()" class="mt2 not-rounded outlined-primary-button h5 regular no-hover mr-auto p2 px4 line-height0 mb1"> <i class="el-icon-back pr1"></i>Afbryd
                </button>
                <button type="button" @click="openconfirmPayproff()" class=" mt2 not-rounded action-button h5 regular no-hover ml-auto p2 px4 line-height0 mb1">Næste <i class="pl1 el-icon-right"></i>
                </button>
              </div> -->
              <template slot="footer" slot-scope="props">
                <!-- Back and next -->
                <div class="col-12 p0 flex" :class="props.isLastStep ? 'justify-between' : 'justify-end'">
                  <button type="button" @click="props.prevTab()" class="outlined-primary-button h5 m0 line-height-4 regular px2 p1" v-if="props.activeTabIndex > 0">
                    <span class="ml1"><i class="el-icon-back"></i></span>
                    <span class="inline-block">Tilbage</span>
                  </button>
                  <button type="button" @click="props.isLastStep ? openconfirmPayproff() : props.nextTab()" class="action-button h5 m0 line-height-4 regular px2 p1">
                    <span class="inline-block">{{props.isLastStep ? 'Indsend' : 'Næste'}}</span>
                    <span class="ml1"><i class="el-icon-right"></i></span>
                  </button>
                </div>
              </template>
            </form-wizard>
          </el-form>
        </div>
      </div>
    </b-modal>
    <b-modal  centered hide-footer v-model="confirmPayproff" id="confirmPayproff" :no-close-on-backdrop="true" ref="confirmPayproff" size="lg">
        <div class="col-12 flex justify-end items-center pt1 p0 mx-auto modal-header">
          <button class="ml-auto h4 p0 primary-white-button pointer close" @click="closeconfirmPayproff()">
            <i class="el-icon-circle-close"></i>
          </button>
        </div>
        <div class="clearfix white-background">
          <div class="flex flex-column items-start col-12 pb3 pt1 px3">
            <p class="muted-color h6 pt1" >Er du en politisk udsat person? (PEP)</p>
            <p class="h6 semi-bold py1 mt1" >Hvad er en politisk eksponeret person?</p>
            <p class="h6 mt1 center">Jeg bekræfter og siger sandfærdigt, som om jeg var under ed, at:</p>
            <div class="col-12 flex justify-start my2">
              <template>
                <el-radio v-model="isPep" :label="true">Ja</el-radio>
                <el-radio v-model="isPep" :label="false">Nej</el-radio>
              </template>
            </div>
          </div>
        </div>
        <div class="flex ">
            <button type="button" @click="closeconfirmPayproff()" class=" mt2 not-rounded outlined-primary-button h5 regular no-hover mr-auto p2 px4 line-height0 mb1"> <i class="el-icon-back pr1"></i>Tilbage
            </button>
            <button type="button" @click="verify()" class="mt2 not-rounded action-button h5 regular no-hover ml-auto p2 px4 line-height0 mb1">Sende <i class="pl1 el-icon-right"></i>
            </button>
        </div>
    </b-modal>
    <b-modal  centered hide-header size="lg" hide-footer id="termspopup" v-model="termspopup"  ref="termspopup">
      <div class="col-12 flex justify-end items-center white-background ">
        <button type="button" @click="termspopup = false" class="white-button no-border not-rounded gibson ">
          <span>
          <i class="el-icon-close"></i>
          </span>
        </button>
      </div>
      <div class="py1 col-12 relative" style="width:100%;height:95%;" >
        <iframe :src="termslink" frameborder="0" style="overflow:hidden;padding:10px;overflow-x:hidden;overflow-y:hidden;height:100%;width:100%;position:absolute;top:0px;left:0px;right:0px;bottom:0px" height="100%" width="100%">
        </iframe>
      </div>
    </b-modal>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    <ErrorHandler ref="errorMsg"></ErrorHandler>
  </div>
</template>
<script>
import datepicker from 'vuejs-datepicker'
import {en, da} from 'vuejs-datepicker/dist/locale'
import VuePdfApp from 'vue-pdf-app'
import SignaturePad from 'signature_pad'
import Simplert from 'vue2-simplert'
import loading from 'vue-full-loading'
const ErrorHandler = () => import('@/components/ErrorHandler')
export default {
  name: 'contract-main',
  components: {
    VuePdfApp,
    loading,
    Simplert,
    ErrorHandler,
    en,
    da,
    datepicker,
    SignaturePad
  },
  data () {
    return {
      contractID: '',
      contactId: '',
      contact: '',
      confirmTerms: false,
      contractStatus: '',
      ConfirmVisible: false,
      haaId: '',
      serviceUrl: '',
      contractInfo: '',
      selectedDocumentVersion: '',
      show: false,
      overlay: 1,
      label: 'Loading...',
      contractpdflink: '/static/pdf/sample.pdf',
      contractdetails: [],
      documentPath: '',
      homeownerID: 0,
      salesPersonbitrix: '',
      loading: false,
      showMobile: false,
      info: [],
      pdf: [],
      page: 1,
      historypage: '',
      comments: [],
      textarea: [],
      activeName: 'Comment',
      documentId: '',
      loaded: 1,
      activepage: 0,
      filteredcomments: [],
      commentmanagementloading: true,
      stepsarr: [],
      viewer: '',
      anotations: [],
      activedocumentId: '',
      partnerName: '',
      composeFormVisible: false,
      composeLoading: false,
      composeForm: {
        to: '',
        title: '',
        message: '',
        image: ''
      },
      disablecomment: false,
      webview: 'false',
      haspayproff: false,
      payproffform: false,
      confirmstatus: '',
      payprofform: {
        fornavn: '',
        efternavn: '',
        mellemnavn: '',
        fodelsdag: '',
        Adresse: '',
        zipcode: '',
        by: '',
        stat: '',
        land: 'DK',
        email: '',
        telefonnummer: '',
        telcountrycode: 45,
        cprnummer: '',
        sprog: 'da',
        currency: 'DKK',
        cvr: '',
        companyName: ''
      },
      activeNames: [],
      payprofformfules: {
        fornavn: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit fornavn',
          trigger: 'blur'
        }],
        efternavn: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit efternavn',
          trigger: 'blur'
        }],
        fodelsdag: [{
          required: true,
          type: 'date',
          message: 'Du bedes indtaste dit fodelsdag',
          trigger: 'change'
        }],
        Adresse: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit Adresse',
          trigger: 'blur'
        }],
        zipcode: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit postnummer',
          trigger: 'blur'
        }],
        by: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit by',
          trigger: 'blur'
        }],
        stat: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit stat',
          trigger: 'blur'
        }],
        land: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit gyldig land',
          trigger: 'blur'
        }],
        email: [{
          required: true,
          type: 'email',
          message: 'Du bedes indtaste en gyldig e-mail',
          trigger: 'blur'
        }],
        telefonnummer: [{
          required: true,
          type: 'number',
          min: 10000000,
          max: 99999999,
          message: 'Du bedes indtaste en gyldig telnummer',
          trigger: 'blur'
        }],
        telcountrycode: [{
          required: true,
          type: 'number',
          message: 'Du bedes indtaste dit code',
          trigger: 'blur'
        }],
        cprnummer: [{
          required: true,
          type: 'number',
          min: 1000000000,
          max: 9999999999,
          message: 'Du bedes indtaste en cpr',
          trigger: 'blur'
        }]
      },
      countryData: {
        'BD': 'Bangladesh',
        'BE': 'Belgium',
        'BF': 'Burkina Faso',
        'BG': 'Bulgaria',
        'BA': 'Bosnia and Herzegovina',
        'BB': 'Barbados',
        'WF': 'Wallis and Futuna',
        'BL': 'Saint Barthelemy',
        'BM': 'Bermuda',
        'BN': 'Brunei',
        'BO': 'Bolivia',
        'BH': 'Bahrain',
        'BI': 'Burundi',
        'BJ': 'Benin',
        'BT': 'Bhutan',
        'JM': 'Jamaica',
        'BV': 'Bouvet Island',
        'BW': 'Botswana',
        'WS': 'Samoa',
        'BQ': 'Bonaire, Saint Eustatius and Saba ',
        'BR': 'Brazil',
        'BS': 'Bahamas',
        'JE': 'Jersey',
        'BY': 'Belarus',
        'BZ': 'Belize',
        'RU': 'Russia',
        'RW': 'Rwanda',
        'RS': 'Serbia',
        'TL': 'East Timor',
        'RE': 'Reunion',
        'TM': 'Turkmenistan',
        'TJ': 'Tajikistan',
        'RO': 'Romania',
        'TK': 'Tokelau',
        'GW': 'Guinea-Bissau',
        'GU': 'Guam',
        'GT': 'Guatemala',
        'GS': 'South Georgia and the South Sandwich Islands',
        'GR': 'Greece',
        'GQ': 'Equatorial Guinea',
        'GP': 'Guadeloupe',
        'JP': 'Japan',
        'GY': 'Guyana',
        'GG': 'Guernsey',
        'GF': 'French Guiana',
        'GE': 'Georgia',
        'GD': 'Grenada',
        'GB': 'United Kingdom',
        'GA': 'Gabon',
        'SV': 'El Salvador',
        'GN': 'Guinea',
        'GM': 'Gambia',
        'GL': 'Greenland',
        'GI': 'Gibraltar',
        'GH': 'Ghana',
        'OM': 'Oman',
        'TN': 'Tunisia',
        'JO': 'Jordan',
        'HR': 'Croatia',
        'HT': 'Haiti',
        'HU': 'Hungary',
        'HK': 'Hong Kong',
        'HN': 'Honduras',
        'HM': 'Heard Island and McDonald Islands',
        'VE': 'Venezuela',
        'PR': 'Puerto Rico',
        'PS': 'Palestinian Territory',
        'PW': 'Palau',
        'PT': 'Portugal',
        'SJ': 'Svalbard and Jan Mayen',
        'PY': 'Paraguay',
        'IQ': 'Iraq',
        'PA': 'Panama',
        'PF': 'French Polynesia',
        'PG': 'Papua New Guinea',
        'PE': 'Peru',
        'PK': 'Pakistan',
        'PH': 'Philippines',
        'PN': 'Pitcairn',
        'PL': 'Poland',
        'PM': 'Saint Pierre and Miquelon',
        'ZM': 'Zambia',
        'EH': 'Western Sahara',
        'EE': 'Estonia',
        'EG': 'Egypt',
        'ZA': 'South Africa',
        'EC': 'Ecuador',
        'IT': 'Italy',
        'VN': 'Vietnam',
        'SB': 'Solomon Islands',
        'ET': 'Ethiopia',
        'SO': 'Somalia',
        'ZW': 'Zimbabwe',
        'SA': 'Saudi Arabia',
        'ES': 'Spain',
        'ER': 'Eritrea',
        'ME': 'Montenegro',
        'MD': 'Moldova',
        'MG': 'Madagascar',
        'MF': 'Saint Martin',
        'MA': 'Morocco',
        'MC': 'Monaco',
        'UZ': 'Uzbekistan',
        'MM': 'Myanmar',
        'ML': 'Mali',
        'MO': 'Macao',
        'MN': 'Mongolia',
        'MH': 'Marshall Islands',
        'MK': 'Macedonia',
        'MU': 'Mauritius',
        'MT': 'Malta',
        'MW': 'Malawi',
        'MV': 'Maldives',
        'MQ': 'Martinique',
        'MP': 'Northern Mariana Islands',
        'MS': 'Montserrat',
        'MR': 'Mauritania',
        'IM': 'Isle of Man',
        'UG': 'Uganda',
        'TZ': 'Tanzania',
        'MY': 'Malaysia',
        'MX': 'Mexico',
        'IL': 'Israel',
        'FR': 'France',
        'IO': 'British Indian Ocean Territory',
        'SH': 'Saint Helena',
        'FI': 'Finland',
        'FJ': 'Fiji',
        'FK': 'Falkland Islands',
        'FM': 'Micronesia',
        'FO': 'Faroe Islands',
        'NI': 'Nicaragua',
        'NL': 'Netherlands',
        'NO': 'Norway',
        'NA': 'Namibia',
        'VU': 'Vanuatu',
        'NC': 'New Caledonia',
        'NE': 'Niger',
        'NF': 'Norfolk Island',
        'NG': 'Nigeria',
        'NZ': 'New Zealand',
        'NP': 'Nepal',
        'NR': 'Nauru',
        'NU': 'Niue',
        'CK': 'Cook Islands',
        'XK': 'Kosovo',
        'CI': 'Ivory Coast',
        'CH': 'Switzerland',
        'CO': 'Colombia',
        'CN': 'China',
        'CM': 'Cameroon',
        'CL': 'Chile',
        'CC': 'Cocos Islands',
        'CA': 'Canada',
        'CG': 'Republic of the Congo',
        'CF': 'Central African Republic',
        'CD': 'Democratic Republic of the Congo',
        'CZ': 'Czech Republic',
        'CY': 'Cyprus',
        'CX': 'Christmas Island',
        'CR': 'Costa Rica',
        'CW': 'Curacao',
        'CV': 'Cape Verde',
        'CU': 'Cuba',
        'SZ': 'Swaziland',
        'SY': 'Syria',
        'SX': 'Sint Maarten',
        'KG': 'Kyrgyzstan',
        'KE': 'Kenya',
        'SS': 'South Sudan',
        'SR': 'Suriname',
        'KI': 'Kiribati',
        'KH': 'Cambodia',
        'KN': 'Saint Kitts and Nevis',
        'KM': 'Comoros',
        'ST': 'Sao Tome and Principe',
        'SK': 'Slovakia',
        'KR': 'South Korea',
        'SI': 'Slovenia',
        'KP': 'North Korea',
        'KW': 'Kuwait',
        'SN': 'Senegal',
        'SM': 'San Marino',
        'SL': 'Sierra Leone',
        'SC': 'Seychelles',
        'KZ': 'Kazakhstan',
        'KY': 'Cayman Islands',
        'SG': 'Singapore',
        'SE': 'Sweden',
        'SD': 'Sudan',
        'DO': 'Dominican Republic',
        'DM': 'Dominica',
        'DJ': 'Djibouti',
        'DK': 'Denmark',
        'VG': 'British Virgin Islands',
        'DE': 'Germany',
        'YE': 'Yemen',
        'DZ': 'Algeria',
        'US': 'United States',
        'UY': 'Uruguay',
        'YT': 'Mayotte',
        'UM': 'United States Minor Outlying Islands',
        'LB': 'Lebanon',
        'LC': 'Saint Lucia',
        'LA': 'Laos',
        'TV': 'Tuvalu',
        'TW': 'Taiwan',
        'TT': 'Trinidad and Tobago',
        'TR': 'Turkey',
        'LK': 'Sri Lanka',
        'LI': 'Liechtenstein',
        'LV': 'Latvia',
        'TO': 'Tonga',
        'LT': 'Lithuania',
        'LU': 'Luxembourg',
        'LR': 'Liberia',
        'LS': 'Lesotho',
        'TH': 'Thailand',
        'TF': 'French Southern Territories',
        'TG': 'Togo',
        'TD': 'Chad',
        'TC': 'Turks and Caicos Islands',
        'LY': 'Libya',
        'VA': 'Vatican',
        'VC': 'Saint Vincent and the Grenadines',
        'AE': 'United Arab Emirates',
        'AD': 'Andorra',
        'AG': 'Antigua and Barbuda',
        'AF': 'Afghanistan',
        'AI': 'Anguilla',
        'VI': 'U.S. Virgin Islands',
        'IS': 'Iceland',
        'IR': 'Iran',
        'AM': 'Armenia',
        'AL': 'Albania',
        'AO': 'Angola',
        'AQ': 'Antarctica',
        'AS': 'American Samoa',
        'AR': 'Argentina',
        'AU': 'Australia',
        'AT': 'Austria',
        'AW': 'Aruba',
        'IN': 'India',
        'AX': 'Aland Islands',
        'AZ': 'Azerbaijan',
        'IE': 'Ireland',
        'ID': 'Indonesia',
        'UA': 'Ukraine',
        'QA': 'Qatar',
        'MZ': 'Mozambique'
      },
      languagesData: {
        'af': 'Afrikaans',
        'sq': 'Albanian - shqip',
        'am': 'Amharic - አማርኛ',
        'ar': 'Arabic - العربية',
        'an': 'Aragonese - aragonés',
        'hy': 'Armenian - հայերեն',
        'ast': 'Asturian - asturianu',
        'az': 'Azerbaijani - azərbaycan dili',
        'eu': 'Basque - euskara',
        'be': 'Belarusian - беларуская',
        'bn': 'Bengali - বাংলা',
        'bs': 'Bosnian - bosanski',
        'br': 'Breton - brezhoneg',
        'bg': 'Bulgarian - български',
        'ca': 'Catalan - català',
        'ckb': 'Central Kurdish - کوردی (دەستنوسی عەرەبی)',
        'zh': 'Chinese - 中文',
        'zh-HK': 'Chinese (Hong Kong) - 中文（香港）',
        'zh-CN': 'Chinese (Simplified) - 中文（简体）',
        'zh-TW': 'Chinese (Traditional) - 中文（繁體）',
        'co': 'Corsican',
        'hr': 'Croatian - hrvatski',
        'cs': 'Czech - čeština',
        'da': 'Danish - dansk',
        'nl': 'Dutch - Nederlands',
        'en': 'English',
        'en-AU': 'English (Australia)',
        'en-CA': 'English (Canada)',
        'en-IN': 'English (India)',
        'en-NZ': 'English (New Zealand)',
        'en-ZA': 'English (South Africa)',
        'en-GB': 'English (United Kingdom)',
        'en-US': 'English (United States)',
        'eo': 'Esperanto - esperanto',
        'et': 'Estonian - eesti',
        'fo': 'Faroese - føroyskt',
        'fil': 'Filipino',
        'fi': 'Finnish - suomi',
        'fr': 'French - français',
        'fr-CA': 'French (Canada) - français (Canada)',
        'fr-FR': 'French (France) - français (France)',
        'fr-CH': 'French (Switzerland) - français (Suisse)',
        'gl': 'Galician - galego',
        'ka': 'Georgian - ქართული',
        'de': 'German - Deutsch',
        'de-AT': 'German (Austria) - Deutsch (Österreich)',
        'de-DE': 'German (Germany) - Deutsch (Deutschland)',
        'de-LI': 'German (Liechtenstein) - Deutsch (Liechtenstein)',
        'de-CH': 'German (Switzerland) - Deutsch (Schweiz)',
        'el': 'Greek - Ελληνικά',
        'gn': 'Guarani',
        'gu': 'Gujarati - ગુજરાતી',
        'ha': 'Hausa',
        'haw': 'Hawaiian - ʻŌlelo Hawaiʻi',
        'he': 'Hebrew - עברית',
        'hi': 'Hindi - हिन्दी',
        'hu': 'Hungarian - magyar',
        'is': 'Icelandic - íslenska',
        'id': 'Indonesian - Indonesia',
        'ia': 'Interlingua',
        'ga': 'Irish - Gaeilge',
        'it': 'Italian - italiano',
        'it-IT': 'Italian (Italy) - italiano (Italia)',
        'it-CH': 'Italian (Switzerland) - italiano (Svizzera)',
        'ja': 'Japanese - 日本語',
        'kn': 'Kannada - ಕನ್ನಡ',
        'kk': 'Kazakh - қазақ тілі',
        'km': 'Khmer - ខ្មែរ',
        'ko': 'Korean - 한국어',
        'ku': 'Kurdish - Kurdî',
        'ky': 'Kyrgyz - кыргызча',
        'lo': 'Lao - ລາວ',
        'la': 'Latin',
        'lv': 'Latvian - latviešu',
        'ln': 'Lingala - lingála',
        'lt': 'Lithuanian - lietuvių',
        'mk': 'Macedonian - македонски',
        'ms': 'Malay - Bahasa Melayu',
        'ml': 'Malayalam - മലയാളം',
        'mt': 'Maltese - Malti',
        'mr': 'Marathi - मराठी',
        'mn': 'Mongolian - монгол',
        'ne': 'Nepali - नेपाली',
        'no': 'Norwegian - norsk',
        'nb': 'Norwegian Bokmål - norsk bokmål',
        'nn': 'Norwegian Nynorsk - nynorsk',
        'oc': 'Occitan',
        'or': 'Oriya - ଓଡ଼ିଆ',
        'om': 'Oromo - Oromoo',
        'ps': 'Pashto - پښتو',
        'fa': 'Persian - فارسی',
        'pl': 'Polish - polski',
        'pt': 'Portuguese - português',
        'pt-BR': 'Portuguese (Brazil) - português (Brasil)',
        'pt-PT': 'Portuguese (Portugal) - português (Portugal)',
        'pa': 'Punjabi - ਪੰਜਾਬੀ',
        'qu': 'Quechua',
        'ro': 'Romanian - română',
        'mo': 'Romanian (Moldova) - română (Moldova)',
        'rm': 'Romansh - rumantsch',
        'ru': 'Russian - русский',
        'gd': 'Scottish Gaelic',
        'sr': 'Serbian - српски',
        'sh': 'Serbo-Croatian - Srpskohrvatski',
        'sn': 'Shona - chiShona',
        'sd': 'Sindhi',
        'si': 'Sinhala - සිංහල',
        'sk': 'Slovak - slovenčina',
        'sl': 'Slovenian - slovenščina',
        'so': 'Somali - Soomaali',
        'st': 'Southern Sotho',
        'es': 'Spanish - español',
        'es-AR': 'Spanish (Argentina) - español (Argentina)',
        'es-419': 'Spanish (Latin America) - español (Latinoamérica)',
        'es-MX': 'Spanish (Mexico) - español (México)',
        'es-ES': 'Spanish (Spain) - español (España)',
        'es-US': 'Spanish (United States) - español (Estados Unidos)',
        'su': 'Sundanese',
        'sw': 'Swahili - Kiswahili',
        'sv': 'Swedish - svenska',
        'tg': 'Tajik - тоҷикӣ',
        'ta': 'Tamil - தமிழ்',
        'tt': 'Tatar',
        'te': 'Telugu - తెలుగు',
        'th': 'Thai - ไทย',
        'ti': 'Tigrinya - ትግርኛ',
        'to': 'Tongan - lea fakatonga',
        'tr': 'Turkish - Türkçe',
        'tk': 'Turkmen',
        'tw': 'Twi',
        'uk': 'Ukrainian - українська',
        'ur': 'Urdu - اردو',
        'ug': 'Uyghur',
        'uz': 'Uzbek - o‘zbek',
        'vi': 'Vietnamese - Tiếng Việt',
        'wa': 'Walloon - wa',
        'cy': 'Welsh - Cymraeg',
        'fy': 'Western Frisian',
        'xh': 'Xhosa',
        'yi': 'Yiddish',
        'yo': 'Yoruba - Èdè Yorùbá',
        'zu': 'Zulu - isiZulu'
      },
      confirmPayproff: false,
      partnerprofile: [],
      partnertelephone: '',
      partneremail: '',
      isPep: true,
      termspopup: false,
      projectthreadid: '',
      activeprojectId: '',
      childprojects: [],
      partnerchildprojects: [],
      parentID: '',
      contractType: '',
      offerType: '',
      projectTitle: '',
      submittedIndustries: [],
      industryID: '',
      scale: 120,
      config: {
        toolbar: {
          toolbarViewerLeft: false
        }
      },
      pdfStr: '',
      pdfStrlink: '',
      termsdata: [],
      termslabel: 'Accepter vores betingelser',
      termslink: 'https://www.haandvaerker.dk/om/betingelser',
      signaturePad: ''
    }
  },
  created () {
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    var pathArray = window.location.href.split('/')
    this.salesPersonbitrix = pathArray[pathArray.length - 4]
    this.partnerName = pathArray[pathArray.length - 5]
    this.haaId = pathArray[pathArray.length - 3]
    this.project_id = pathArray[pathArray.length - 2]
    this.contractID = pathArray[pathArray.length - 1]
    this.historypage = localStorage.getItem('pdfjs.history')
    this.parentID = this.$route.query.parentID
    this.contractType = this.$route.query.contracttype
    this.industryID = this.$route.query.industryID
    this.submittedIndustries = JSON.parse(this.$route.query.submittedindustry)
    this.projectTitle = this.$route.query.projecttitle
    this.offerType = this.$route.query.offertype
    this.childprojects.forEach(o => {
      if (o.IS_PARTNER) {
        this.partnerchildprojects.push(o.ID)
      }
    })
    var x = this
    setTimeout(() => {
      document.querySelector('footer').classList.add('hide')
      x.webview = x.$route.query.webview
      if (x.webview === 'true') {
        document.querySelector('header').classList.add('hide')
        document.querySelector('.sidebar').classList.add('hide')
      }
    }, 500)
    this.getPayproffacc()
    this.getsupplierprofile()
  },
  mounted () {
    this.serviceUrl = 'https://sea-turtle-app-n3xkw.ondigitalocean.app/api/pdfviewer'
    this.getPayproffacc()
    this.getTermsCondition()
  },
  watch: {
  },
  methods: {
    commentAdd (event) {
      console.log(event)
      this.saveComment(event, 1)
    },
    pdfCreated (pdf) {
      // var headers = {
      //   Authorization: 'Bearer ' + this.salesPersonbitrix
      // }
      // var data = {
      // }
      // this.$http.get('https://newcrm.kundematch.dk/webapi/minbolig_data.php?method=document_base64&documentId=84', { headers }, data, { emulateJSON: true }).then(
      //   response => {
      //     var res = response.body
      //     console.log(res)
      //   },
      //   err => {
      //     var error = err.body
      //     this.$refs.errorMsg.showMsg(error)
      //   }
      // )
      var g4string = ''
      setTimeout(() => {
        this.viewer = document.getElementById('pdfViewer')
        console.log('this.viewer', this.viewer)
        console.log('this.viewermain', this.viewer.element.ej2_instances[0])
        var viewers = this.viewer['element'].ej2_instances[0]
        viewers.load(g4string, null)
      }, 1000)
    },
    showcontract () {
      var searchInput = document.querySelectorAll('[data-page-number]')
      var searchinputpage = []
      var thisthisvarvar = this
      searchInput.forEach((a) => {
        if (a.className === 'page') {
          searchinputpage.push(a)
        }
      })
      searchinputpage.forEach((a, index) => {
        if (a.className === 'page') {
          a.addEventListener('mouseup', () => {
            var text = window.getSelection().toString()
            if (text !== '') {
              thisthisvarvar.addComment(index + 1, text)
            }
          })
        }
      })
    },
    getContract () {
      var contractId = this.$route.query.contractId
      this.contractID = contractId
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {
        documentId: this.documentId
      }
      this.$http.post(this.$bitrixapi + 'partner/contract/' + this.contractID + '/preview/document.base64', data, { headers }, { emulateJSON: true }).then(
        response => {
          var res = response.body
          this.contractInfo = res.data
          if (this.contractInfo.file) {
            // let AddBase64String = this.contractInfo.file
            this.documentId = this.contractInfo.documentId
            this.contact = this.contractInfo.CONTACT_TITLE
            this.contactId = this.contractInfo.CONTACT_ID
            this.activeprojectId = this.contractInfo.contracts.PROJECT.ID
            this.contractStatus = this.contractInfo.contracts.STATUS
            this.confirmstatus = this.contractInfo.contracts.DATE_SIGNED_BY_PARTNER
            if (this.contractStatus === 'approved' || this.contractStatus === 'signed') {
              this.disablecomment = true
            }
            // this.pdfStr = this.base64ToArrayBuffer(AddBase64String)
            this.pdfStrlink = this.contractInfo.url
            // this.viewer = document.getElementById('pdfViewer').ej2_instances[0]
            // this.viewer.unload()
            // this.viewer.load('data:application/pdf;base64,' + AddBase64String, null)
            // this.viewer.annotationSettings = { author: this.partnerName }
          }
          if (this.documentId !== '') {
            this.selectedDocumentVersion = this.contractInfo.documentId.toString()
          }
          this.show = false
          this.getmessagesbyProjectID()
        },
        err => {
          this.show = false
          this.formLoading = false
          this.commentIsConfirmed = false
          var error = err.body.message
          this.$refs.errorMsg.showMsg(error)
        }
      )
    },
    base64ToArrayBuffer (base64) {
      var binarystring = window.atob(base64)
      var len = binarystring.length
      var bytes = new Uint8Array(len)
      for (var i = 0; i < len; i++) {
        bytes[i] = binarystring.charCodeAt(i)
      }
      return bytes.buffer
    },
    sendmessage () {
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {
        contactId: this.contactId,
        title: this.composeForm.title,
        message: this.composeForm.message
      }
      this.$http.post(this.$bitrixapi + 'partner/messages/' + this.projectthreadid + '/reply', data, { headers }, { emulateJSON: true })
        .then(
          response => {
            if (response.body.success) {
              this.composeFormVisible = false
              let obj = {
                title: 'Gennemført!',
                message: 'Besked sendt',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
            } else {
              this.$message({
                type: 'error',
                message: response.body.message
              })
            }
          },
          err => {
            this.$message({
              type: 'error',
              message: err.body.message
            })
          }
        )
    },
    changeDocument () {
      this.documentId = this.selectedDocumentVersion
      this.getContract()
    },
    documentLoad () {
      if (!this.disablecomment && !this.showMobile) {
        document.getElementById('pdfViewer_annotation_commentPanel').click()
        document.getElementById('pdfViewer_annotation').click()
      }
      document.getElementById('pdfViewer_open').style.display = 'none'
      document.getElementById('pdfViewer_submitForm').style.display = 'none'
      this.viewer.importAnnotation(JSON.parse(this.contractInfo.ANNOTATIONS))
      this.formLoading = false
    },
    exportAnnotation (args) {
      if (this.disablecomment) {
        let obj = {
          title: 'Denne kontrakt er blevet bekræftet, din kommentar vil ikke blive sendt til boligejeren',
          message: '',
          type: 'error',
          customCloseBtnText: 'Luk'
        }
        this.$refs.simplert.openSimplert(obj)
        return
      }
      var m = this
      this.viewer.exportAnnotationsAsObject().then(function (value) {
        var headers = {
          Authorization: 'Bearer ' + m.salesPersonbitrix
        }
        var data = {
          documentId: m.documentId,
          annotation: value
        }
        m.$http.post(m.$bitrixapi + 'partner/contract/' + m.contractID + '/saveAnnotation', data, { headers }, { emulateJSON: true }).then(
          response => {
            console.log(response)
          }
        )
        console.log(value)
      })
    },
    ajaxRequestFailure (args) {
      window.location.reload()
    },
    getsupplierprofile () {
      this.haaId = localStorage.getItem('haaid')
      this.$http.get(this.$bitrixapi + 'supplier/getSupplierInfo/' + this.haaId, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.partnerprofile = res.data
            this.partnertelephone = res.data.MOBILE
            this.partneremail = res.data.EMAIL
            this.payprofform.telefonnummer = Number(res.data.UF_CRM_COMPANY_TELEPHONE)
            this.payprofform.email = res.data.EMAIL
            this.payprofform.by = res.data.UF_CRM_COMPANY_CITY
            this.payprofform.stat = res.data.UF_CRM_COMPANY_CITY
            this.payprofform.Adresse = res.data.UF_CRM_COMPANY_ADDRESS
            this.payprofform.zipcode = res.data.UF_CRM_COMPANY_ZIP_CODE
            this.payprofform.cvr = res.data.UF_CRM_COMPANY_CVR
            this.payprofform.companyName = res.data.TITLE
          } else {
            this.$message({
              type: 'error',
              message: res.message
            })
          }
        },
        (response) => {
          this.$message({
            type: 'error',
            message: response.body.message
          })
        }
      )
    },
    getProjectDetails () {
      var projectid = this.$route.query.projectId
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      this.show = true
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/project/' + projectid, { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.success) {
            this.contractID = res.data.CONTRACT_ID
            this.contractStatus = res.data.CONTRACT_STATUS
            if (this.contractStatus === 'approved' || this.contractStatus === 'signed') {
              this.disablecomment = true
            }
            this.homeownerID = res.data.HOMEOWNER.ID
            this.show = false
            this.getContract()
          } else {
            this.$message({
              type: 'error',
              message: res.message
            })
          }
        },
        response => {
          this.show = false
          if (response.body.message === 'Unauthorized. User has been logged out.') {
            this.refreshtoken()
            setTimeout(() => {
              this.getProjectDetails()
            }, 1000)
          } else {
            this.$message({
              type: 'error',
              message: response.body.message
            })
          }
        })
    },
    getContractByProjectId () {
      this.commentmanagementloading = true
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/contract/' + this.contractID, { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.success) {
            this.contractdetails = res.data
            this.comments = res.data.COMMENTS.reverse()
            this.contractID = this.contractdetails.ID
            this.activedocumentId = res.data.DOCUMENTS.ID
            this.contractpdflink = '/static/pdf/sample.pdf'
            var thisvar = this
            res.data.COMMENTS.forEach((a, index) => {
              thisvar.comments[index]['fromdb'] = true
              thisvar.textarea[index] = a.COMMENTS
            })
            if (this.loaded === 1) {
              setTimeout(() => {
                this.showcontract()
              }, 3000)
            }
            this.loaded = 2
            this.filtercommentsbyId(this.activepage)
            this.loading = false
            this.commentmanagementloading = false
            this.getContractSteps()
          } else {
            this.$message({
              type: 'error',
              message: res.message
            })
            this.loading = false
          }
        },
        response => {
          this.loading = false
          if (response.body.message === 'Unauthorized. User has been logged out.') {
            this.refreshtoken()
            setTimeout(() => {
              this.getContractByProjectId()
            }, 1000)
          } else {
            this.$message({
              type: 'error',
              message: response.body.message
            })
          }
        })
    },
    getContractComments () {
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/contract/comments/' + this.contractID, { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.success) {
            this.comments = res.data.reverse()
            var thisvar = this
            this.comments.forEach((a, index) => {
              thisvar.comments[index]['fromdb'] = true
              thisvar.textarea[index] = a.COMMENTS
            })
            if (this.loaded === 1) {
              setTimeout(() => {
                this.showcontract()
              }, 5000)
            }
            this.loaded = 2
            this.loading = false
          } else {
            this.$message({
              type: 'error',
              message: res.message
            })
            this.loading = false
          }
        },
        response => {
          if (response.body.message === 'Unauthorized. User has been logged out.') {
            this.refreshtoken()
            setTimeout(() => {
              this.getContractComments()
            }, 1000)
          } else {
            this.$message({
              type: 'error',
              message: response.body.message
            })
          }
        })
    },
    getStepbycontent (content) {
      this.stepsarr.forEach(l => {
        if (l.value.toString().includes(content)) {
          return l
        }
        return false
      })
    },
    getContractSteps () {
      // if field 0, they can't edit
      var documents = []
      var steps = []
      var stepsvalue = []
      documents = this.contractdetails.DOCUMENTS[this.contractdetails.DOCUMENTS.length - 1]
      steps = documents.JSON_STEPS
      var arrsteps = Object.entries(steps)
      arrsteps.forEach(a => {
        var arrfield = Object.entries(a)
        arrfield[arrfield.length - 1].forEach(h => {
          if (typeof h === 'object') {
            h['fields'].forEach(n => {
              if (n.field !== 0) {
                var tempvalue = {
                  key: h.key,
                  value: n.default_value
                }
                stepsvalue.push(tempvalue)
                tempvalue = []
              }
            })
          }
        })
      })
      this.stepsarr = stepsvalue
    },
    getPayproffacc () {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.post(this.$bitrixapi + 'partner/payproff/account/exists/', data, { headers }, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.success) {
            this.haspayproff = res.data.exists
            this.getContract()
          } else {
            this.$message({
              type: 'error',
              message: res.message
            })
          }
        },
        response => {
          if (response.body.message === 'Unauthorized. User has been logged out.') {
            this.refreshtoken()
            setTimeout(() => {
              this.getPayproffacc()
            }, 1000)
          } else {
            this.$message({
              type: 'error',
              message: response.body.message
            })
          }
        })
    },
    getTermsCondition () {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'helper/termsAndConditionsPopup', { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          this.termsdata = res.filter(l => { return l.TYPE === 'Partner' })[0]
          this.termslink = this.termsdata.LINK
          this.termslabel = this.termsdata.LABEL
        },
        response => {
          this.$message({
            type: 'error',
            message: response.body.message
          })
        })
    },
    getAnnotations () {
      var thisvar = this
      this.viewer = thisvar.$refs.pdfviewer.ej2Instances
      this.comments.forEach(a => {
        if (a.ANNOTATIONS !== null) {
          console.log('a.ANNOTATIONS', a.ANNOTATIONS)
          thisvar.viewer.annotation.addAnnotation('Highlight', {
            allowedInteractions: a.ANNOTATIONS['allowedInteractions'],
            annotName: a.ANNOTATIONS['annotName'],
            annotationAddMode: a.ANNOTATIONS['annotationAddMode'],
            annotationSelectorSettings: {
              selectionBorderColor: a.ANNOTATIONS['annotationSelectorSettings']['selectionBorderColor'],
              resizerBorderColor: a.ANNOTATIONS['annotationSelectorSettings']['resizerBorderColor'],
              resizerFillColor: a.ANNOTATIONS['annotationSelectorSettings']['resizerFillColor'],
              resizerSize: a.ANNOTATIONS['annotationSelectorSettings']['resizerSize'],
              selectionBorderThickness: a.ANNOTATIONS['annotationSelectorSettings']['selectionBorderThickness'],
              selectorLineDashArray: a.ANNOTATIONS['annotationSelectorSettings']['selectorLineDashArray']
            },
            annotationSettings: {
              isLock: a.ANNOTATIONS['annotationSettings']['annotationAddMode']
            },
            author: thisvar.partnerName,
            bounds: [{
              bottom: a.ANNOTATIONS['bounds']['bottom'],
              height: a.ANNOTATIONS['bounds']['height'],
              left: a.ANNOTATIONS['bounds']['left'],
              top: a.ANNOTATIONS['bounds']['top'],
              right: a.ANNOTATIONS['bounds']['right']
            }],
            bottom: a.ANNOTATIONS['bottom'],
            height: a.ANNOTATIONS['height'],
            left: a.ANNOTATIONS['left'],
            right: a.ANNOTATIONS['right'],
            top: a.ANNOTATIONS['top'],
            width: a.ANNOTATIONS['width'],
            color: a.ANNOTATIONS['color'],
            comments: a.ANNOTATIONS['comments'],
            isAnnotationRotated: a.ANNOTATIONS['isAnnotationRotated'],
            isCommentLock: a.ANNOTATIONS['isCommentLock'],
            isMultiSelect: a.ANNOTATIONS['isMultiSelect'],
            isPrint: a.ANNOTATIONS['isMultiSelect'],
            modifiedDate: a.ANNOTATIONS['isMultiSelect'],
            note: a.ANNOTATIONS['note'],
            opacity: a.ANNOTATIONS['opacity'],
            pageNumber: a.ANNOTATIONS['pageNumber'],
            rect: {
              bottom: a.ANNOTATIONS['rect']['bottom'],
              height: a.ANNOTATIONS['rect']['height'],
              left: a.ANNOTATIONS['rect']['left'],
              right: a.ANNOTATIONS['rect']['right'],
              top: a.ANNOTATIONS['rect']['top'],
              width: a.ANNOTATIONS['rect']['width']
            },
            review: {
              state: a.ANNOTATIONS['review']['state'],
              stateModel: a.ANNOTATIONS['review']['stateModel'],
              author: a.ANNOTATIONS['review']['author'],
              modifiedDate: a.ANNOTATIONS['review']['modifiedDate']
            },
            shapeAnnotationType: a.ANNOTATIONS['shapeAnnotationType'],
            subject: a.ANNOTATIONS['subject'],
            textMarkupAnnotationType: a.ANNOTATIONS['textMarkupAnnotationType'],
            textmarkupcontent: a.ANNOTATIONS['textMarkupContent'],
            textMarkupEndIndex: a.ANNOTATIONS['textMarkupEndIndex'],
            textMarkupStartIndex: a.ANNOTATIONS['textMarkupStartIndex']
          })
        }
      })
    },
    saveComment (item, index) {
      var stepno = 3
      var step = this.getStepbycontent(item['annotation']['textMarkupContent'])
      if (stepno) {
        step = stepno.key
      }
      var page = item['annotation']['pageNumber']
      var highlighttext = item['annotation']['textMarkupContent']
      var desccomment = item['annotation']['note']
      this.$confirm('Er du sikker på, at du vil gemme denne kommentar', {
        confirmButtonText: 'Okay',
        cancelButtonText: 'Afbestille',
        type: 'warning'
      }).then(() => {
        var headers = {
          Authorization: 'Bearer ' + this.salesPersonbitrix
        }
        var data = {
          annotations: item['annotation'],
          documentId: this.activedocumentId,
          annotationId: item['id']
        }
        this.$http.post(this.$bitrixapi + 'partner/contract/comments?contractId=' + this.contractID + '&title=' + step + '&comments=' + desccomment + '&page=' + page + '&highlightedText=' + highlighttext + '&contactId=' + this.homeownerID, data, { headers }, { emulateJSON: true })
          .then(
            response => {
              if (response.body.success) {
                let obj = {
                  title: 'Gennemført!',
                  message: 'Success',
                  type: 'success',
                  customCloseBtnText: 'Luk'
                }
                this.$refs.simplert.openSimplert(obj)
              }
              this.getContractByProjectId()
            },
            err => {
              this.$message({
                type: 'error',
                message: err.body.message
              })
            }
          )
      }).catch(() => {
      })
    },
    addComment (page, selectedtext, step = 3) {
      var haaid = localStorage.getItem('haaid')
      var commentdetails = {
        'HIGHLIGHTED_TEXT': selectedtext,
        'COMMENTS': '',
        'PAGE': page,
        'TITLE': step,
        'STATUS': 'pending',
        'CONTRACT_ID': this.contractID,
        'CONTACT_ID': this.homeownerID,
        'COMPANY_ID': haaid,
        'fromdb': false
      }
      this.comments.unshift(commentdetails)
      this.filteredcomments.unshift(commentdetails)
      var thisvar = this
      this.comments.forEach((a, index) => {
        thisvar.comments[index]['fromdb'] = a.fromdb
        thisvar.textarea[index] = a.COMMENTS
      })
      this.filteredcomments.forEach((b, index) => {
        thisvar.filteredcomments[index]['fromdb'] = b.fromdb
        thisvar.textarea[index] = b.COMMENTS
      })
      commentdetails = []
    },
    clear () {
      this.payprofform = {
        fornavn: '',
        efternavn: '',
        mellemnavn: '',
        fodelsdag: '',
        Adresse: '',
        zipcode: '',
        by: '',
        stat: '',
        land: 'DK',
        email: '',
        telefonnummer: '',
        telcountrycode: '+45',
        cprnummer: '',
        sprog: 'da',
        currency: 'DKK',
        cvr: '',
        companyName: ''
      }
    },
    closeconfirmPayproff () {
      this.confirmPayproff = false
    },
    openconfirmPayproff () {
      var error = 0
      this.$refs['payprofform'].validate((valid) => {
        if (!valid) {
          error = 1
        }
      })
      if (error === 1) { return }
      this.closepayproffform()
      this.confirmPayproff = true
    },
    verify () {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {
        email: this.payprofform.email,
        phoneNumber: this.payprofform.telefonnummer,
        phoneNumberAreaCode: this.payprofform.telcountrycode,
        firstName: this.payprofform.fornavn,
        middleName: this.payprofform.mellemnavn,
        lastName: this.payprofform.efternavn,
        address: this.payprofform.Adresse,
        zipCode: this.payprofform.zipcode,
        city: this.payprofform.by,
        state: this.payprofform.stat,
        country: this.payprofform.land,
        isPep: this.isPep,
        socialSecurityNumber: this.payprofform.cprnummer,
        birthDate: this.payprofform.fodelsdag,
        displayLanguage: this.payprofform.sprog,
        currency: this.payprofform.currency,
        cvr: this.payprofform.cvr,
        companyName: this.payprofform.companyName
      }
      this.$http.post(this.$bitrixapi + 'partner/payproff/account/', data, { headers }, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.closeconfirmPayproff()
            // this.haspayproff = true
            // this.confirmcontract()
            this.getNemIdUrl()
            setTimeout(() => {
              this.$router.push('/customer-projects/project-dashboard?projectId=' + this.activeprojectId)
            }, 3000)
          } else {
            this.$message({
              type: 'error',
              message: res.message
            })
          }
        },
        (response) => {
          this.$message({
            type: 'error',
            message: response.body.message
          })
        }
      )
    },
    getNemIdUrl () {
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {
      }
      this.$http.post(this.$bitrixapi + 'partner/payproff/verify', data, { headers }, { emulateJSON: true }).then(
        response => {
          var res = response.body
          window.open(res.data.URL, '_blank').focus()
        },
        err => {
          this.$message({
            type: 'error',
            message: err.body.message
          })
        }
      )
    },
    initiateSignaturepad () {
      setTimeout(() => {
        var canvas = document.querySelector('canvas')
        this.signaturePad = new SignaturePad(canvas, {
          backgroundColor: 'rgb(255, 255, 255)'
        })
      }, 200)
    },
    clearSignature () {
      this.signaturePad.clear()
    },
    confirmcontract () {
      if (!this.confirmTerms) {
        this.$message({
          type: 'error',
          message: 'Accepter venligst vores vilkår og tjenester'
        })
        return false
      }
      var signature = this.signaturePad
      if (signature.isEmpty()) {
        this.$message({
          type: 'error',
          message: 'Underskriv venligst kontrakten'
        })
        return
      }
      var signaturePng = signature.toDataURL()
      this.loading = true
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {
        signaturePng: signaturePng
      }
      this.$http.post(this.$bitrixapi + 'partner/contract/' + this.contractID + '/approve?messageId=1&fileId=1', data, { headers }, { emulateJSON: true })
        .then(
          response => {
            if (response.body.success) {
              if (this.haspayproff) {
                let obj = {
                  title: 'Gennemført!',
                  message: 'Success',
                  type: 'success',
                  customCloseBtnText: 'Luk'
                }
                this.$refs.simplert.openSimplert(obj)
                setTimeout(() => {
                  this.$router.push('/customer-projects/project-dashboard?projectId=' + this.activeprojectId + '&contactID=' + this.homeownerID + '&parentID=' + this.parentID + '&industryID=' + this.industryID + '&offertype=' + this.offerType + '&childprojects=' + JSON.stringify(this.childprojects) + '&submittedindustry=' + JSON.stringify(this.submittedIndustries) + '&contracttype=' + this.contractType + '&projecttitle=' + this.projectTitle)
                }, 3000)
              } else {
                this.openpayproffform()
              }
            }
          },
          err => {
            if (err.body.message === 'Unauthorized. User has been logged out.') {
              this.refreshtoken()
              setTimeout(() => {
                this.confirmcontract()
              }, 1000)
            } else {
              this.$message({
                type: 'error',
                message: err.body.message
              })
            }
          }
        )
    },
    deletecommentarray (item) {
      this.comments.splice(this.comments.indexOf(item), 1)
      this.textarea.splice(this.textarea.indexOf(item.COMMENTS), 1)
      this.getContractByProjectId()
    },
    deletecomment (item) {
      this.$confirm('Er du sikker på, at du vil slette denne kommentar', {
        confirmButtonText: 'Okay',
        cancelButtonText: 'Afbestille',
        type: 'warning'
      }).then(() => {
        this.commentmanagementloading = true
        var headers = {
          Authorization: 'Bearer ' + this.salesPersonbitrix
        }
        var data = {
        }
        this.$http.post(this.$bitrixapi + 'partner/contract/comments/' + item.ID + '/delete', data, { headers }, { emulateJSON: true })
          .then(
            response => {
              if (response.body.success) {
                let obj = {
                  title: 'Gennemført!',
                  message: 'Success',
                  type: 'success',
                  customCloseBtnText: 'Luk'
                }
                this.$refs.simplert.openSimplert(obj)
                this.getContractByProjectId()
              }
            },
            err => {
              this.$message({
                type: 'error',
                message: err.body.message
              })
            }
          )
      }).catch(() => {
      })
    },
    filtercommentsbyId (page) {
      var filtered = []
      var thisthisvar = this
      filtered = this.comments.filter(a => {
        return a.PAGE === page
      })
      filtered.forEach((b, index) => {
        if (b.HIGHLIGHTED_TEXT !== null && b.HIGHLIGHTED_TEXT !== '') {
          thisthisvar.hightlighttext(b.HIGHLIGHTED_TEXT)
        }
        thisthisvar.textarea[index] = b.COMMENTS
      })
      this.filteredcomments = filtered
    },
    hightlighttext (text) {
      var textactula = document.querySelectorAll('[data-page-number="' + this.activepage + '"] > .textLayer > span')
      textactula.forEach(z => {
        const Special = /[\\[{().+?|^&]/g
        if (z.innerHTML.includes(text)) {
          var textvalue = z.innerHTML
          if (Special.test(textvalue)) { textvalue = textvalue.replace(Special, '\\$&') }
          let regExp = new RegExp(text, 'gi')
          z.innerHTML = (z.textContent).replace(regExp, '<marker>$&</marker>')
        }
      })
    },
    refreshtoken () {
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.post(this.$bitrixapi + 'partner/refreshToken', data, { headers }, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.success) {
              localStorage.setItem('id_token_portalbitrix', res.data.NEW_TOKEN)
              this.salesPersonbitrix = res.data.NEW_TOKEN
            } else {
              console.log('something is wrong with refreshing the token')
              this.$router.push('/login')
            }
          },
          response => {
            console.log('something is wrong with refreshing the token')
            this.$router.push('/login')
          }
        )
    },
    getmessagesbyProjectID () {
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {
      }
      this.$http.get(this.$bitrixapi + 'partner/messages?projectId=' + this.activeprojectId, { headers }, data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body.data
            this.projectthreadid = res[0].THREAD_ID
          },
          response => {
            this.$message({
              type: 'error',
              message: response.body.message
            })
          }
        )
    },
    showComposeForm () {
      if (this.composeForm.message === '') {
        this.composeForm.message = 'Jeg har tjekket filen og har nogle kommentarer. Kontroller venligst'
      }
      if (this.composeForm.title === '') {
        this.composeForm.title = 'Gennemgå Draft Contract Pdf'
      }
      this.composeFormVisible = true
    },
    hideComposeForm () {
      this.composeFormVisible = false
    },
    uploadImage (file, fileList) {
      this.composeForm.image = fileList
      var fileSize = file.size / 1024 / 1024
      var fileLimitMB = 1
      if (fileSize > fileLimitMB) {
        this.removeUpload(file)
        this.$message.error('File size can not exceed 1MB!')
      }
    },
    removeUpload (file) {
      var images = this.composeForm.image
      for (var i = 0; i < images.length; i++) {
        if (file.uid === images[i].uid) {
          images.splice(i, 1)
        }
      }
      images = this.composeForm.image
    },
    pagesRenderedHandler (pdfapp) {
      this.pdf = pdfapp
      this.activepage = pdfapp.page
      var thisvar = this
      this.pdf.bindEvents('pagechanging', (a) => {
        thisvar.page = a.page
      })
    },
    openpayproffform () {
      this.payproffform = true
    },
    closepayproffform () {
      this.payproffform = false
    },
    validateCreatePayproffFirstTab () {
      return true
    }
  }
}
</script>
<style>
  .e-pdfviewer:not(.e-pv-mobile-view) .e-pv-main-container {
    min-height: 1100px!important;
  }
  #payproffform___BV_modal_body_ .modal-header {
    display: block;
  }
  #payproffform___BV_modal_body_ .close {
        color: #003645!important;
        background-color: #fff!important;
  }
  #payproffform___BV_modal_body_ button.close  {
        padding: 0px!important;
  }
  #payproffform .el-form-item__label {
    margin: 0px;
    padding: 0px;
    font-size: 17px;
    color: #003645;
  }
  #payproffform .el-input__inner {
    font-size: 17px;
    color: #003645;
  }
  #payproffform .el-input__inner {
    border-color: #003645;
    border-radius: 2px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 20px #00000005;
  }
  #payproffform .el-select {
      width: 100%;
  }
  #payproffform___BV_modal_body_ .vdp-datepicker input:focus {
    border: 0px!important;
  }
  #payproffform___BV_modal_body_ .vdp-datepicker input{
      height: 40px;
      width: 100% ;
      border-radius: 2px;
      background: #FFFFFF 0% 0% no-repeat padding-box;
      box-shadow: 0px 0px 20px #00000005;
      padding-left: 15px;
      border-width: 1px!important;
      border-color: #003645!important;
      border: 2px solid;
  }
  @media only screen and (max-width: 600px) {
    .highlights {
      max-height: 1100px;
    }
  }
  #termspopup .modal-body {
    height:800px;
  }
  #termspopup .modal-content {
    width:1200px;
  }
  #termspopup {
    left: -20%!important;
  }
  #payproff .wizard-header {
    display: none;
  }
  #contract-main-viewer marker {
    background-color: aqua;
  }
  #contract-main-viewer .el-input__inner {
    -webkit-appearance: auto;
  }
  #contract-main-viewer .pointer {
    cursor: url(/cursor_1.png) 4 12, auto;
  }
  #contract-main-viewer .loader,
  .loader:before,
  .loader:after {
    border-radius: 50%;
  }
  .font12 {
    font-size: 12px;
  }
  .font14 {
    font-size: 14px;
  }
  #contract-main-viewer .loader {
    color: #143130;
    font-size: 11px;
    text-indent: -99999em;
    margin: 55px auto;
    position: relative;
    width: 10em;
    height: 10em;
    box-shadow: inset 0 0 0 1em;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
  }
  #contract-main-viewer .loader:before,
  .loader:after {
    position: absolute;
    content: '';
  }
  #contract-main-viewer .el-textarea.is-disabled .el-textarea__inner {
      background-color: #ffffff;
      border-color: #dfe2e9;
      color: #7d8085;
      cursor: not-allowed;
  }
  #contract-main-viewer .loader:before {
    width: 5.2em;
    height: 10.2em;
    background: white;
    border-radius: 10.2em 0 0 10.2em;
    top: -0.1em;
    left: -0.1em;
    -webkit-transform-origin: 5.2em 5.1em;
    transform-origin: 5.2em 5.1em;
    -webkit-animation: load2 2s infinite ease 1.5s;
    animation: load2 2s infinite ease 1.5s;
  }
  #contract-main-viewer .loader:after {
    width: 5.2em;
    height: 10.2em;
    background: white;
    border-radius: 0 10.2em 10.2em 0;
    top: -0.1em;
    left: 5.1em;
    -webkit-transform-origin: 0px 5.1em;
    transform-origin: 0px 5.1em;
    -webkit-animation: load2 2s infinite ease;
    animation: load2 2s infinite ease;
  }
  #signature {
    border: 1px solid lightgray;
    height: 300px;
    width: 550px;
  }

  .wrap {
    height: 300px;
    width: 550px;
  }

  #signature-pad {
    height: 300px;
    width: 550px;
  }
  .commentdiv {
      height: 900px;
      overflow: auto;
    }
  @media (max-width:27em) {
    .mm0 {
    margin: 0px;
    }
    .mmx-auto {
      margin-left: auto;
      -webkit-box-pack: center;
      justify-content: center;
    }
    .mmb5 {
      margin-bottom: 5rem;
    }
    .mpt1 {
      padding-top: .5rem;
    }
    .mobile-flex-column {
      flex-direction: column!important;
      align-items: center;
    }
    .xs-col-12 {
      width: 100%;
    }
    .mobile-100 {
      width: 100%!important;
    }
    .mp2 {
      padding: 1em;
    }
    .commentdiv {
      height: 750px;
      overflow:auto;
    }
    #cvrfrom .mp0 {
      padding: 0!important;
    }
  }
  @-webkit-keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes pulse {
      0% {
        height: 1em;
        width:1em;
        margin-top: -0.5em;
        margin-left: -0.5em;
        opacity: 0.2;
      }
      50% {
        opacity: 0.9;
        height: 3em;
        width: 3em;
        margin-top: -1.5em;
        margin-left: -1.5em;
      }
      100% {
        opacity: 0.2;
        height: 1em;
        width: 1em;
        margin-top: -0.5em;
        margin-left: -0.5em;
      }
  }
</style>



// WEBPACK FOOTER //
// contract-viewer.vue?df875c2e